import React from 'react';
import classnames from 'classnames';

import CheckMarkSVG from '../../../images/svg/icons8-checkmark';
import './column-with-checkbox.scss';

interface IProps {
    isActive: boolean;
    children?: React.ReactNode;
    withGreyedCheckMark?: boolean;
    isHidden?: boolean;
}

const ColumnWithCheckbox = (props: IProps) => {
    const { isActive, children, withGreyedCheckMark, isHidden } = props;
    const isCheckmarkHidden = !withGreyedCheckMark && !isActive || isHidden;

    return (
        <div
            className={classnames('column-with-checkbox',
                { 'column-with-checkbox--active': isActive },
                { 'column-with-checkbox--hidden': isCheckmarkHidden })}
        >
            {withGreyedCheckMark && <div className='column-with-checkbox__checkbox'>
                <CheckMarkSVG/>
            </div>}
            <div className='column-with-checkbox__content'>{children}</div>
        </div>
    );
};

export default ColumnWithCheckbox;
